/* eslint-disable max-len */
import React from 'react';
import { Col, Row, Card, CardTitle, CardBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import styles from './usefullinks.module.scss';
import Clickable from '../../../../components/clickable/Clickable';

const UsefulLinks = ({ data, handelFullScreen, fullScreenMode }) => (
  <Col lg={12} className={styles.cardHeight}>
    <Card className={styles.Card} style={{ height: fullScreenMode?'100vh': '', width: fullScreenMode?'100vw': '' }}>
      <CardTitle className="mt-3">
        <Col lg={12}>
          <Row>
            <Col className={styles.title}>
              <FormattedMessage
                id="airfields.useful.links"
                defaultText="Useful Links"
              />
            </Col>
            <Col lg={5}>
              {!fullScreenMode && (
                <Clickable onClick={() => { handelFullScreen(true, 5); }}>
                  <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end' }}>
                    <FullscreenIcon />
                  </p>
                </Clickable>
              )}
              {fullScreenMode && (
                <Clickable onClick={() => { handelFullScreen(false, 5); }}>
                  <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', marginRight: '2%' }}>
                    X
                  </p>
                </Clickable>
              )}
            </Col>
          </Row>
        </Col>
      </CardTitle>
      <hr className={styles.hrLine} />
      <CardBody className={styles.usefullinksCardBody}>
        {data && data.length
          ? data.map(link => (
            <div className={styles.link}>
              <span className={styles.linkUrl}>
                <a href={`${link.url}`} rel="noopener noreferrer" target="_blank" style={{ color: '#4183c4' }}>{link.text}</a>
              </span>
            </div>
          ))
          : (
            <div className={styles.noLinksText}>
              No Links Added
            </div>
          )}
      </CardBody>
    </Card>
  </Col>
);

export default UsefulLinks;
